<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Nuevo Pago
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Comision Create -->
          <sys-form :inputs.sync="payment_create"/>
        <!--end: Comision Create -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.go(-1)">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import promotersService from '@/services/promoters'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'PaymentCreate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      comisions: [],
      attachments: [],
      isInterest: 0,
      payment_create: {
        comision_id: {
          name: 'Comisión',
          hint: 'Selecciona una comisión',
          value: null,
          type: 'select',
          options: [],
          size: 12,
          validate: 'required'
        },
        attachment_id: {
          name: 'Anexos',
          hint: 'Selecciona un anexo',
          value: null,
          type: 'select',
          options: [],
          size: 12
        },
        monthly_cut_attachment_id: {
          name: 'Anexos',
          hint: 'Selecciona un anexo',
          value: null,
          type: 'select',
          options: [],
          size: 12
        },
        amount: {
          name: 'Monto del Pago',
          hint: 'Monto a Pagar',
          value: '',
          type: 'number',
          size: 4,
          validate: 'required'
        },
        date_payment: {
          name: 'Fecha de Pago',
          hint: 'Fecha de Pago',
          value: '',
          type: 'date',
          size: 4,
          validate: 'required'
        },
        iva: {
          name: 'Aplica IVA',
          hint: 'IVA',
          value: null,
          type: 'select',
          options: [
            { value: false, text: 'No', selected: true },
            { value: true, text: 'Si' }
          ],
          size: 4,
          validate: 'required'
        }
      }
    }
  },
  beforeCreate: function () {
    const id = this.$route.params.id
    promotersService.getById(this.$route.params.id).then(res => {
      this.isInterest = res.data.comision_interest
      if (this.isInterest) {
        this.payment_create.attachment_id.disabled = true
        this.payment_create.attachment_id.hide = true
      } else {
        this.payment_create.monthly_cut_attachment_id.disabled = true
        this.payment_create.monthly_cut_attachment_id.hide = true
      }
    })

    promotersService.listComisions(id).then(res => {
      this.payment_create.comision_id.options = res.data.map(comision => {
        return { value: comision.id, text: '(' + comision.id + ') $' + comision.pending }
      })
    })
  },
  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let promoterId = this.$route.params.id
          let body = this.processForm(this.payment_create)
          body['promoter_id'] = promoterId
          body['status'] = 'Generado'
          let service = promotersService.postPayment(body)

          this.sendForm(service).then(res => {
            if (res.error) {
              alert(res.error)
            } else {
              this.$router.push({ name: 'promoter', params: { id: promoterId } })
            }
          }).catch(err => {
            console.log(JSON.stringify(err.statusText))
          })
        }
      })
    }
  },
  watch: {
    'payment_create.comision_id.value': function (newComision, oldComision) {
      const id = newComision.value
      if (this.isInterest) {
        promotersService.listMonthlyCutAttachments(id).then(res => {
          this.payment_create.monthly_cut_attachment_id.options = res.data.map(attachment => {
            return { value: attachment.id, text: '(' + attachment.attachment_id + ') ' + attachment.investor + ' $' + attachment.avaliable_amount }
          })
        })
      } else {
        promotersService.listAttachments(id).then(res => {
          this.payment_create.attachment_id.options = res.data.map(attachment => {
            return { value: attachment.id, text: '(' + attachment.attachment_id + ') ' + attachment.investor_name + ' $' + attachment.avaliable_amount }
          })
        })
      }
    },
    'payment_create.attachment_id.value': function (newAttachment, oldAttachment) {
      promotersService.getAttachment(newAttachment.value).then(res => {
        this.payment_create.amount.value = res.data.avaliable_amount
      })
    },
    'payment_create.monthly_cut_attachment_id.value': function (newAttachment, oldAttachment) {
      promotersService.getMonthlyCutAttachment(newAttachment.value).then(res => {
        this.payment_create.amount.value = res.data.avaliable_amount
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/promoters/payments/PaymentCreate.vue